import { validationTypes } from "../../../../data/ValidationTypes";
import { FileFormats } from "../../../../components/finalForms/forms/libs/data/fileFormatTypes"
import { FormFieldTypes } from "../../../../data/formFieldType";

export const AddApplicationFormData = {
    name: "Add Application",
    initialState: {
        applicationName: "",
        clientKey: "",
        secretKey: "",
        isActive: true,
    },

    section: [
        {
            title: "Application Details",
            row: {},
            style: { sectionStyle: "row mb-3" },
            fields: [
                {
                    id: "ApplicationName",
                    label: "Application Name",
                    Field_Name: "applicationName",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "applicationName",
                    fieldSetting: {
                        placeholder: "Enter Application Name",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: { containerCss: "col-md-6 mb-2" },
                },
                {
                    id: "ClientKey",
                    label: "Client ID",
                    Field_Name: "clientKey",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "clientKey",
                    fieldSetting: {
                        placeholder: "Enter Client Key",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: { containerCss: "col-md-6 mb-2" },
                },
                {
                    id: "SecretKey",
                    label: "Secret Key",
                    Field_Name: "secretKey",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "secretKey",
                    fieldSetting: {
                        placeholder: "Enter Secret Key",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: { containerCss: "col-md-6 mb-2" },
                },
                {
                    id: "isActive",
                    label: "Is Active",
                    Field_Name: "isActive",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "isActive",
                    fieldSetting: {
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-md-6 mb-2 mt-4",
                    },
                },
            ],
        },
    ],

    formSetting: {
        isViewOnly: false,
    },
};
